import { useGLTF } from '@react-three/drei'
import { InstancedRigidBodies } from '@react-three/rapier'
import { useMemo } from 'react'

export default function Burgers()
{
    const {nodes} = useGLTF('./hamburger.glb')
    // console.log(nodes)

    const scale = 0.25
    const burgersCount = 100

    const instances = useMemo(()=>{
        const instances = []
        for(let i=0; i<burgersCount; i++ ){
            instances.push({
                key: 'burger_instance_' + i,
                position: [
                    (Math.random()-0.5)*8 / scale,
                    (6 + i*1) / scale,
                    (Math.random()-0.5)*8 / scale],
                rotation: [Math.random(), Math.random(), Math.random()]
            })
        }
        return instances
    },[])
    
    return <>

        {/* bottomBun */}
        <InstancedRigidBodies scale={scale} instances={instances}>
            <instancedMesh args={[
                nodes.bottomBun.geometry,
                nodes.bottomBun.material,
                burgersCount]}/>
        </InstancedRigidBodies>

        {/* cheese */}
        <InstancedRigidBodies scale={scale} instances={instances}>
            <instancedMesh args={[
                nodes.cheese.geometry,
                nodes.cheese.material,
                burgersCount]}/>
        </InstancedRigidBodies>

        {/* meat */}
        <InstancedRigidBodies scale={scale} instances={instances}>
            <instancedMesh args={[
                nodes.meat.geometry,
                nodes.meat.material,
                burgersCount]}/>
        </InstancedRigidBodies>

        {/* topBun */}
        <InstancedRigidBodies scale={scale} instances={instances}>
            <instancedMesh args={[
                nodes.bottomBun.geometry,
                nodes.bottomBun.material,
                burgersCount]}/>
        </InstancedRigidBodies>

    </>
}